<template>
  <div>
    <Head
      :title="seoTitle"
      :prepend-name-to-title="false"
      :description="seoDescription"
      :keywords="seoKeywords"
    />

    <Container :disable-modals="true">
      <template v-if="popularAuctionGroupFirst.length > 0">
        <div class="bg-sky-400">
          <div class="container mx-auto pt-8 pb-6">
            <h1 class="font-bold text-4xl text-white mb-4">
              Populaire Kavels
            </h1>

            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              <div
                v-for="(popularAuction, i) in popularAuctionGroupFirst"
                :key="popularAuction.id"
              >
                <HomeAuctionBlock
                  :auction="popularAuction"
                  :class="{ 'lg:hidden': popularAuctionGroupFirst.length === 6 && i === popularAuctionGroupFirst.length - 1 }"
                />
              </div>
            </div>
          </div>
        </div>
      </template>

      <div class="container mx-auto py-8">
        <template v-if="themeAuctions.length > 0">
          <div class="flex flex-col md:flex-row md:items-center md:space-x-8 mb-4">
            <h2 class="font-bold text-4xl">
              Lopende Thema Veilingen
            </h2>

            <Link
              class="block text-right md:text-left text-sm underline hover:no-underline"
              :href="route('frontend.theme-auctions.index')"
            >
              Alle veilingen
            </Link>
          </div>

          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            <div
              v-for="(themeAuction, i) in themeAuctions"
              :key="themeAuction.slug"
            >
              <HomeThemeAuctionBlock
                :theme-auction="themeAuction"
                :class="{ 'lg:hidden': themeAuctions.length === 6 && i === themeAuctions.length - 1 }"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="text-center font-xl my-10">
            Beste Bezoeker,<br>
            <br>
            De veiling van vandaag is helaas al afgelopen.<br>
            Morgen om 09:00 beginnen we met een nieuwe veiling!<br>
            <br>
            <br>
            (<strong>TIP:</strong> Ook kun je even kijken bij onze andere veilingsite - <a
              href="https://flimdeal.nl"
              class="underline uppercase"
              target="_blank"
            >
              klik hier
            </a>)
          </div>
        </template>
      </div>

      <template v-if="popularAuctionGroupSecond.length > 0">
        <div class="bg-sky-400">
          <div class="container mx-auto pt-10 pb-6">
            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              <div
                v-for="(popularAuction, i) in popularAuctionGroupSecond"
                :key="popularAuction.id"
              >
                <HomeAuctionBlock
                  :auction="popularAuction"
                  :class="{ 'lg:hidden': popularAuctionGroupSecond.length === 6 && i === popularAuctionGroupSecond.length - 1 }"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </Container>
  </div>
</template>

<script>
import {Link} from '@inertiajs/vue2';
import Head from '../../Partials/Head.vue';
import Container from '../../Partials/Container.vue';
import Home from '../../Layouts/Home.vue';
import IndexPageBase from '../../Mixins/IndexPageBase';
import HomeAuctionBlock from '../../Partials/New/HomeAuctionBlock.vue';
import HomeThemeAuctionBlock from '../../Partials/New/HomeThemeAuctionBlock.vue';

export default {
  components: {
    Container,
    Head,
    Link,
    HomeAuctionBlock,
    HomeThemeAuctionBlock,
  },

  mixins: [IndexPageBase],

  layout: Home,

  props: {
    popularAuctionGroupFirst: {
      required: true,
      type: Array,
    },

    popularAuctionGroupSecond: {
      required: true,
      type: Array,
    },

    themeAuctions: {
      required: true,
      type: Array,
    },

    error: {
      required: false,
      type: String,
      default: null,
    },

    success: {
      required: false,
      type: String,
      default: null,
    },
  },

  mounted() {
    if (this.error) {
      this.$eventHub.$emit('notification', 'error', this.error, true);
    }
    if (this.success) {
      this.$eventHub.$emit('notification', 'success', this.success, true);
    }
  },
};
</script>
